var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFyldLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 157 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fyld Logo Full") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-1.1-UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation_desktop",
    transform: "translate(-40.000000, -24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation",
    transform: "translate(40.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "brand/full-logo/black-background",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FYLD_RGB_BBG_FULL-LOGO_COLOUR"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    fill: "#FFF308",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 32.0408163,
    height: 32
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    transform: "translate(7.048980, 7.040000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#151515",
    points: "15.3795918 24.96 19.2244898 24.96 19.2244898 19.2 24.9918367 19.2 24.9918367 15.36 19.2244898 15.36 19.2244898 11.52 24.9918367 11.52 24.9918367 7.68 15.3795918 7.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#151515",
    points: "0 24.96 3.84489796 24.96 3.84489796 3.84 7.68979592 3.84 7.68979592 24.96 11.5346939 24.96 11.5346939 3.84 24.9918367 3.84 24.9918367 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "47.4204082 19.2 51.2653061 19.2 51.2653061 11.52 58.955102 11.52 58.955102 7.68 51.2653061 7.68 51.2653061 3.84 58.955102 3.84 58.955102 0 47.4204082 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "110.220408 0 106.37551 0 106.37551 19.2 117.910204 19.2 117.910204 15.36 110.220408 15.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.620408,0 L133.289796,0 L133.289796,19.2 L141.620408,19.2 C146.554694,19.2 149.95102,14.5792 149.95102,9.6 C149.95102,4.6208 146.554694,0 141.620408,0 Z M141.620408,15.36 L137.134694,15.36 L137.134694,3.84 L141.620408,3.84 C144.222122,3.84 146.106122,6.5536 146.106122,9.6 C146.106122,12.6464 144.222122,15.36 141.620408,15.36 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "82.6653061 5.9264 76.7826122 0.0512 74.065551 2.7648 80.7428571 9.4336 80.7428571 19.2 84.5877551 19.2 84.5877551 9.4336 91.2650612 2.7648 88.548 0.0512"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFyldLogoFull);
export default __webpack_public_path__ + "static/media/fyld-logo-full.c82607f93ed54203e066978e04431b7b.svg";
export { ForwardRef as ReactComponent };